import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui';
import SelectedMealListItemStyles from './SelectedMealListItemStyles';
import CheckedMealItem from './CheckedMealItem';
import UncheckedMealItem from './UncheckedMealItem';

const SelectedMealListItems = ({ passenger, meal, mealType, label, className, classes }) => {
  const meals = passenger.meals;
  let isNone = false;
  let isMealComplete = false;
  let fullMeal;

  if (!meals || !meals.length || (meals.length === 1 && !meals[ 0 ].id)) {
    return null;
  }

  let selectedMeal = meals.find(meal => meal.type && meal.type.toLowerCase() === mealType);
  isMealComplete = !!selectedMeal;
  if (meal && meal.items && meal.items.length && selectedMeal) {
    fullMeal = meal.items.find(completeMeal => completeMeal.id === selectedMeal.id);
    isNone = fullMeal && fullMeal.description && fullMeal.description.toLowerCase() === 'none';
    let hasSubselection = fullMeal && fullMeal.subselection;
    isMealComplete = hasSubselection ? selectedMeal && selectedMeal.description : isMealComplete;
  }

  if (isMealComplete && !isNone) {
    return (
      <CheckedMealItem
        label={label}
        className={className}
        passengerId={passenger.id}
        mealId={selectedMeal.id}
      />
    );
  } else {
    return (
      <UncheckedMealItem
        label={label}
        className={className}
        passengerId={passenger.id}
        mealId='no-main-meal'
      />
    );
  }
};

SelectedMealListItems.propTypes = {
  passenger: PropTypes.object,
  meal: PropTypes.object,
  label: PropTypes.string,
  mealType: PropTypes.string,
  className: PropTypes.string,
  classes: PropTypes.object,
};

export default withStyles(SelectedMealListItemStyles)(SelectedMealListItems);



// WEBPACK FOOTER //
// ./src/components/meals/selectedMealListItem/SelectedMealListItem.js